import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { AssetVersionUrlPipe } from './asset-version-url.pipe';

@Pipe({
  name: 'galleryCoverUrl',
  // pure: false,
  standalone: true,
})
@Injectable({
  providedIn: 'root',
})
export class GalleryCoverUrlPipe implements PipeTransform {
  constructor(private assetVersionUrl: AssetVersionUrlPipe) {}

  async transform(
    uuid: string,
    coverWidth: number,
    coverHeight: number,
    width: number,
    height: number
  ): Promise<string> {
    // console.log('gallery cover url pipe');

    if (!width) width = 500; // ssr sometimes needs this
    if (!uuid) return '';
    // const uuid = gallery.cover.uuid;

    const aspectRatio = height / width;
    const coverAspectRatio = coverHeight / coverWidth;

    const diff = aspectRatio - coverAspectRatio;

    if (diff > 0) {
      width *= diff + 1;
    }

    const extension = 'jpg';
    return this.assetVersionUrl.get(uuid, width, coverWidth, coverHeight, extension, { allowDouble: true });
  }
}
